import { library } from "@fortawesome/fontawesome-svg-core";

//Solid
import { faCheck as faBadgeCheck } from "@fortawesome/free-solid-svg-icons/faCheck";
import { faMedal as faBadge } from "@fortawesome/free-solid-svg-icons/faMedal";
import { faDownload as faArrowDownToLine } from "@fortawesome/free-solid-svg-icons/faDownload";
import { faCircleArrowDown } from "@fortawesome/free-solid-svg-icons/faCircleArrowDown";
import { faCircleArrowRight } from "@fortawesome/free-solid-svg-icons/faCircleArrowRight";
import { faArrowUpRightFromSquare } from "@fortawesome/free-solid-svg-icons/faArrowUpRightFromSquare";
import { faBan } from "@fortawesome/free-solid-svg-icons/faBan";
import { faTag } from "@fortawesome/free-solid-svg-icons/faTag";
import { faServer } from "@fortawesome/free-solid-svg-icons/faServer";
import { faChartLine } from "@fortawesome/free-solid-svg-icons/faChartLine";
import { faArrowRightArrowLeft } from "@fortawesome/free-solid-svg-icons/faArrowRightArrowLeft";
import { faHandHoldingDollar } from "@fortawesome/free-solid-svg-icons/faHandHoldingDollar";
import { faChartLine as faChartLineUp } from "@fortawesome/free-solid-svg-icons/faChartLine";
import { faBuilding } from "@fortawesome/free-solid-svg-icons/faBuilding";

//light (using free solid equivalents)
import { faAngleRight } from "@fortawesome/free-solid-svg-icons/faAngleRight";
import { faCircleQuestion } from "@fortawesome/free-solid-svg-icons/faCircleQuestion";
import { faGlobe } from "@fortawesome/free-solid-svg-icons/faGlobe";
import { faBullseye } from "@fortawesome/free-solid-svg-icons/faBullseye";
import { faChevronLeft } from "@fortawesome/free-solid-svg-icons/faChevronLeft";
import { faClipboardCheck } from "@fortawesome/free-solid-svg-icons/faClipboardCheck";
import { faCircleDot } from "@fortawesome/free-solid-svg-icons/faCircleDot";
import { faLock } from "@fortawesome/free-solid-svg-icons/faLock";
import { faHandshake } from "@fortawesome/free-solid-svg-icons/faHandshake";
import { faPaperPlane } from "@fortawesome/free-solid-svg-icons/faPaperPlane";
import { faClose } from "@fortawesome/free-solid-svg-icons/faClose";
import { faTrash } from "@fortawesome/free-solid-svg-icons/faTrash";
import { faCircleUser } from "@fortawesome/free-solid-svg-icons/faCircleUser";
import { faCircle } from "@fortawesome/free-solid-svg-icons/faCircle";
import { faDollarSign } from "@fortawesome/free-solid-svg-icons/faDollarSign";
import { faFileCircleCheck } from "@fortawesome/free-solid-svg-icons/faFileCircleCheck";
import { faFileLines } from "@fortawesome/free-solid-svg-icons/faFileLines";
import { faUser } from "@fortawesome/free-solid-svg-icons/faUser";
import { faTag as faTagLight } from "@fortawesome/free-solid-svg-icons/faTag";
import { faCheck as faBadgeCheckLight } from "@fortawesome/free-solid-svg-icons/faCheck";
import { faMedal as faBadgeLight } from "@fortawesome/free-solid-svg-icons/faMedal";
import { faShareNodes } from "@fortawesome/free-solid-svg-icons/faShareNodes";
import { faEllipsisVertical } from "@fortawesome/free-solid-svg-icons/faEllipsisVertical";
import { faBarcode as faBarcodeRead } from "@fortawesome/free-solid-svg-icons/faBarcode";
import { faBan as faBanLight } from "@fortawesome/free-solid-svg-icons/faBan";
import { faDonate } from "@fortawesome/free-solid-svg-icons/faDonate";
import { faCircleDollarToSlot } from "@fortawesome/free-solid-svg-icons/faCircleDollarToSlot";
import { faCircleExclamation } from "@fortawesome/free-solid-svg-icons/faCircleExclamation";
import { faTriangleExclamation } from "@fortawesome/free-solid-svg-icons/faTriangleExclamation";
import { faPenToSquare } from "@fortawesome/free-solid-svg-icons/faPenToSquare";
import { faBasketShopping } from "@fortawesome/free-solid-svg-icons/faBasketShopping";
import { faUsers } from "@fortawesome/free-solid-svg-icons/faUsers";
import { faTh } from "@fortawesome/free-solid-svg-icons/faTh";
import { faServer as faServerLight } from "@fortawesome/free-solid-svg-icons/faServer";
import { faChartLine as faChartLineLight } from "@fortawesome/free-solid-svg-icons/faChartLine";
import { faCog } from "@fortawesome/free-solid-svg-icons/faCog";
import { faLink } from "@fortawesome/free-solid-svg-icons/faLink";
import { faHome } from "@fortawesome/free-solid-svg-icons/faHome";
import { faLayerGroup } from "@fortawesome/free-solid-svg-icons/faLayerGroup";
import { faPlay as faScrubber } from "@fortawesome/free-solid-svg-icons/faPlay";
import { faClock } from "@fortawesome/free-solid-svg-icons/faClock";
import { faClock as faCircleThreeQuartersStroke } from "@fortawesome/free-solid-svg-icons/faClock";
import { faCircleCheck } from "@fortawesome/free-solid-svg-icons/faCircleCheck";
import { faCircleXmark } from "@fortawesome/free-solid-svg-icons/faCircleXmark";
import { faLockOpen } from "@fortawesome/free-solid-svg-icons/faLockOpen";
import { faCopy } from "@fortawesome/free-solid-svg-icons/faCopy";
import { faTachometerAlt as faGaugeSimpleMin } from "@fortawesome/free-solid-svg-icons/faTachometerAlt";
import { faImages as faAlbumCollection } from "@fortawesome/free-solid-svg-icons/faImages";

//regular (using solid equivalents since regular versions not available in free)
import { faUpload } from "@fortawesome/free-solid-svg-icons/faUpload";
import { faFilter } from "@fortawesome/free-solid-svg-icons/faFilter";
import { faChevronRight } from "@fortawesome/free-solid-svg-icons/faChevronRight";
import { faQuestion } from "@fortawesome/free-solid-svg-icons/faQuestion";
import { faCheck as faBadgeCheckRegular } from "@fortawesome/free-solid-svg-icons/faCheck";
import { faMedal as faBadgeRegular } from "@fortawesome/free-solid-svg-icons/faMedal";

export default function iconPack() {
  //Solid
  library.add(
    faBadgeCheck,
    faBadge,
    faArrowDownToLine,
    faCircleArrowDown,
    faCircleArrowRight,
    faArrowUpRightFromSquare,
    faBan,
    faTag,
    faServer,
    faChartLine,
    faBadgeCheckRegular,
    faBadgeRegular,
    faArrowRightArrowLeft,
    faHandHoldingDollar,
    faChartLineUp,
    faBuilding,
    faUpload,
    faFilter,
    faChevronRight,
    faQuestion,
  );
  //Light
  library.add(
    faAngleRight,
    faCircleQuestion,
    faGlobe,
    faBullseye,
    faChevronLeft,
    faClipboardCheck,
    faCircleDot,
    faLock,
    faLockOpen,
    faHandshake,
    faPaperPlane,
    faClose,
    faTrash,
    faCircleUser,
    faCircle,
    faDollarSign,
    faFileCircleCheck,
    faFileLines,
    faUser,
    faTagLight,
    faBadgeCheckLight,
    faBadgeLight,
    faShareNodes,
    faEllipsisVertical,
    faBarcodeRead,
    faBanLight,
    faDonate,
    faCircleDollarToSlot,
    faCircleExclamation,
    faTriangleExclamation,
    faPenToSquare,
    faBasketShopping,
    faUsers,
    faTh,
    faServerLight,
    faChartLineLight,
    faCog,
    faLink,
    faHome,
    faLayerGroup,
    faScrubber,
    faClock,
    faCircleThreeQuartersStroke,
    faCircleCheck,
    faCircleXmark,
    faCopy,
    faGaugeSimpleMin,
    faAlbumCollection,
  );
}
